import React from 'react'
import Img1 from '../../assets/myWork.png';
import Img2 from '../../assets/myWork2.png';
import Img3 from '../../assets/myWork3.png';
import Img4 from '../../assets/myWork4.jpg';
import Img5 from '../../assets/myWork5.png';
import Img7 from '../../assets/myWork7.png';

import './portfolio.css';

const Portfolio = () => {
  return (
    <section id='portfolio'>
      <h5>My Projects</h5>
      <h2 className='headerPortfolio'> &#x276C;Portfolio/&#x276D;</h2>

      <div className='container portfolio_container'>
        <article className='portfolio_item padding-6'>
          <div className='portfolio_item_image'>
            <img src={Img3} alt='' className='paddingd-6' />
          </div>
          <h3>Smoothies and Beyond (Work Project)</h3>
          <a href='https://www.smoothiesandbeyond.com/' className='btn' target='_blank' rel="noreferrer">Website</a>
        </article>

        <article className='portfolio_item padding-6'>
          <div className='portfolio_item_image'>
            <img src={Img4} alt='' className='paddingd-6' />
          </div>
          <h3>Manifect (Work Project - Business Inactive)</h3>
          <a href='https://github.com/mnathuw/Manifect_main' className='btn' target='_blank' rel="noreferrer">Github</a>
        </article>

        <article className='portfolio_item padding-6'>
          <div className='portfolio_item_image'>
            <img src={Img5} alt='' className='paddingd-6' />
          </div>
          <h3>Fais voler le clown avec les lettres (Work Project)</h3>
          <a href='https://github.com/mnathuw/Clown-Letter-Game' className='btn' target='_blank' rel="noreferrer">Github</a>
        </article>

        <article className='portfolio_item padding-6'>
          <div className='portfolio_item_image'>
            <img src={Img2} alt='' className='paddingd-6' />
          </div>
          <h3>Car Rental Management </h3>
          <a href='https://github.com/mnathuw/CRAMS' className='btn' target='_blank' rel="noreferrer">Github</a>
        </article>

        <article className='portfolio_item'>
          <div className='portfolio_item_image'>
            <img src={Img1} alt='' />
          </div>
          <h3>Topic Modeling Research Papers</h3>
          <a href='https://github.com/mnathuw/Topic-Modeling-Research-Papers' className='btn' target='_blank' rel="noreferrer">Github</a>
        </article>
        <article className='portfolio_item'>
          <div className='portfolio_item_image'>
            <img src={Img7} alt='' />
          </div>
          <h3>Potato Network (Ongoing)</h3>
          <a href='https://drive.google.com/drive/folders/1vt01h0Bmtgbw82w8LrIMPp8skIKJlYV4' className='btn' target='_blank' rel="noreferrer">UX|UI Design</a>
        </article>
      </div>
    </section>
  )
}

export default Portfolio